<template>
    <b-alert show variant="danger">
        <div class="d-flex align-items-center">
            <i class="fas fa-exclamation-triangle"></i>
            <div class="pl-3">
                <p class="font-weight-bold mb-0 text-uppercase">
                    {{ $t('auth.account_banned') }}
                </p>
                <i18n path="auth.account_banned_message" tag="span">
                    <template #tos>
                        <span
                            class="text-cinnabar cursor-pointer"
                            @click="redirectTOS"
                        >
                            {{ $t('auth.tos') }}
                        </span>
                    </template>
                </i18n>
            </div>
        </div>
    </b-alert>
</template>

<script>
export default {
    name: 'AccountBannedAlert',
    methods: {
        redirectTOS() {
            this.$helpers.redirectStore('/term-and-conditions');
        },
    },
};
</script>
